import ReservationsTable from "../Pages/Reservations/Reservations_Table";
import ViewReservations from "../Pages/Reservations/View_Reservations";
import CreateReservation from "../Pages/Reservations/Create_Reservation";

import { Navigate } from "react-router";

const role=localStorage.getItem("role")
export const ReservationsRoutes = [
  {
    path: '/',
    element: <ReservationsTable/>
  },
  {
    path: '/ViewReservations/:id',
    element: <ViewReservations />
  },
  {
    path: '/AddBuchungen',
    element: role !== 'manager' ? <Navigate to="/" replace /> : <CreateReservation />
  },
];
